"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSyncWalletErrorResponse = exports.SyncWalletResponseErrorCode = exports.SyncWalletResponseStatusCode = void 0;
const joi_1 = __importDefault(require("joi"));
var SyncWalletResponseStatusCode;
(function (SyncWalletResponseStatusCode) {
    SyncWalletResponseStatusCode[SyncWalletResponseStatusCode["SUCCESS"] = 200] = "SUCCESS";
    SyncWalletResponseStatusCode[SyncWalletResponseStatusCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    SyncWalletResponseStatusCode[SyncWalletResponseStatusCode["SYNC_ERROR"] = 400] = "SYNC_ERROR";
    SyncWalletResponseStatusCode[SyncWalletResponseStatusCode["OUTAGE"] = 502] = "OUTAGE";
    SyncWalletResponseStatusCode[SyncWalletResponseStatusCode["UNKNOWN_ERROR"] = 500] = "UNKNOWN_ERROR";
})(SyncWalletResponseStatusCode = exports.SyncWalletResponseStatusCode || (exports.SyncWalletResponseStatusCode = {}));
var SyncWalletResponseErrorCode;
(function (SyncWalletResponseErrorCode) {
    SyncWalletResponseErrorCode["BAD_REQUEST"] = "BAD_REQUEST";
    SyncWalletResponseErrorCode["SYNC_ERROR"] = "SYNC_ERROR";
})(SyncWalletResponseErrorCode = exports.SyncWalletResponseErrorCode || (exports.SyncWalletResponseErrorCode = {}));
// validation
const syncWalletErrorResponseSchema = joi_1.default.object({
    success: joi_1.default.boolean().required().valid(false),
    error: joi_1.default.object({
        code: joi_1.default.string()
            .allow(...Object.values(SyncWalletResponseErrorCode))
            .required(),
        title: joi_1.default.string(),
        message: joi_1.default.string(),
    }).required(),
    walletState: joi_1.default.object(),
});
const isSyncWalletErrorResponse = (value) => {
    return !syncWalletErrorResponseSchema.validate(value).error;
};
exports.isSyncWalletErrorResponse = isSyncWalletErrorResponse;
